import * as $ from 'jquery';

const knownElements = new Set();

function isClickSynthetic(e) {
    return e.screenX === 0 && e.screenY === 0;
}

export function onLoad(element) {
    element = element.length ? element.get(0) : element;
    let inputs = element.querySelectorAll('input, select, textarea, .ui.dropdown.selection');
    inputs && inputs.forEach((input) => {
            if (!knownElements.has(input)) {
                knownElements.add(input);
                input.addEventListener('focusin', (e) => {
                    const form = e.currentTarget.form || $(e.currentTarget).parents('form');
                    form.lastFocusedInput = e.currentTarget;
                });
            }
        });
    let checkoutForms = element.querySelectorAll('form[name="checkout"]');
    checkoutForms && checkoutForms.forEach((form) => {
        if (!knownElements.has(form)) {
            knownElements.add(form);
            let submitButtons = form.querySelectorAll('button[type="submit"]');
            let couponSubmitButton = form.querySelector("button[name='checkout[coupon][submit]']");
            submitButtons.forEach((button) => {
                if (!knownElements.has(button)) {
                    knownElements.add(button);
                    button.addEventListener('click', (e) => {
                        if (e.isTrusted && !isClickSynthetic(e)) {
                            e.currentTarget.form.lastFocusedInput = e.currentTarget;
                        }
                    });
                }
            });
            form.addEventListener('submit', (e) => {
                let form = e.currentTarget;
                if (form.lastFocusedInput &&
                    form.lastFocusedInput.name &&
                    form.lastFocusedInput.name.match(/\[coupon]/)
                ) {
                    form.submitWithCouponApplyButton = true;
                }
            });
            form.addEventListener('formdata', (e) => {
                if (e.currentTarget.submitWithCouponApplyButton) {
                    submitButtons.forEach((button) => {
                        if (button !== couponSubmitButton &&
                            button.name &&
                            e.formData.has(button.name)
                        ) {
                            e.formData.delete(button.name);
                        }
                    });
                    e.formData.set(couponSubmitButton.name, "1");
                }
            });
        }
    });
}
